export default __webpack_public_path__ + "1008f207ce5dd412b2e0756eeb5ea23f.pdf";